import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import * as subdomains from '@webapp/sdk/subdomains';
import { Action } from 'redux';
import { UpdateSubdomain, UpdateSubdomainSuccess, UpdateSubdomainError } from '../action-creators';
import { UPDATE_SUBDOMAIN } from '../actions';
import { NewSubdomain } from '@services/subdomains/types/new-subdomain';
import AppState from '../../state';


export const updateSubdomainEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateSubdomain>(UPDATE_SUBDOMAIN),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([action, state]) => {
      try {

        const artistId = state.artist.active?.shortId as string;

        const newSubdomain: NewSubdomain = {
          ownerId: artistId,
          subdomain: action.subdomainName
        };
        const subdomain = await subdomains.update(newSubdomain);
        
        return new UpdateSubdomainSuccess(subdomain);
      } catch (err) {
        return new UpdateSubdomainError(err.message)
      }
    })
  );